module.exports = __webpack_public_path__ + "static/img/sy-8.b5fc40d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/sy-8.png
// module id = VB3I
// module chunks = 63